import { Helmet } from "react-helmet";

export default function NewStudents() {
  return (
    <div>
      <Helmet>
        <title>School Fees - New Students | Firdaus-Gate Model Schools</title>
        <meta
          name="description"
          content="View school fees information for new students at Firdaus-Gate Model Schools. Affordable quality Islamic education in Magboro, Ogun State."
        />
        <meta
          property="og:title"
          content="School Fees - New Students | Firdaus-Gate"
        />
        <meta
          property="og:description"
          content="School fees information for new students at Firdaus-Gate Model Schools."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.firdaus-gate.com/school-fees/new-students"
        />
        <meta
          property="og:image"
          content="https://www.firdaus-gate.com/favicon.ico"
        />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="School Fees - New Students" />
        <meta
          name="twitter:description"
          content="View school fees for new students at Firdaus-Gate Model Schools."
        />
        <link
          rel="canonical"
          href="https://www.firdaus-gate.com/school-fees/new-students"
        />
      </Helmet>
      new...
    </div>
  );
}
